'use strict';

var _ = require('lodash');
var SkinnyMarketCabinSposOptGroupTransformerFactory = function SkinnyMarketCabinSposOptGroupTransformerFactory(DataTransformer) {
  function SkinnyMarketCabinSposOptGroupTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['rom-analysis-skinny-services-mode', 'rom-analysis-skinny-services-reference-mode'];
  }
  SkinnyMarketCabinSposOptGroupTransformer.prototype = Object.create(DataTransformer.prototype);
  SkinnyMarketCabinSposOptGroupTransformer.constructor = SkinnyMarketCabinSposOptGroupTransformer;
  SkinnyMarketCabinSposOptGroupTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType.indexOf(sourceType) > -1;
  };
  SkinnyMarketCabinSposOptGroupTransformer.prototype.getCacheKey = function (metrics, metricDescriptor, sourceType) {
    return sourceType;
  };
  SkinnyMarketCabinSposOptGroupTransformer.prototype.isCacheable = function () {
    return true;
  };
  SkinnyMarketCabinSposOptGroupTransformer.prototype.transform = function (data) {
    var dataset = data.domain.marketCabinSPOSOptList;
    _.forEach(dataset, function (record) {
      record.actualRevenue = {
        individual: getActualScenarioProp(record.idvResType, 'revenue'),
        group: getActualScenarioProp(record.groupResType, 'revenue')
      };
      record.maxRevenue = {
        individual: getMaxRevenueScenarioProp(record.idvResType, 'revenue'),
        group: getMaxRevenueScenarioProp(record.groupResType, 'revenue')
      };
      record.minRevenue = {
        individual: record.idvResType && record.idvResType.minRevenueScenario ? record.idvResType.minRevenueScenario.revenue : 0,
        group: record.groupResType && record.groupResType.minRevenueScenario ? record.groupResType.minRevenueScenario.revenue : 0
      };
      record.revenueGap = {
        individual: getMaxRevenueScenarioProp(record.idvResType, 'revenue') - getActualScenarioProp(record.idvResType, 'revenue'),
        group: getMaxRevenueScenarioProp(record.groupResType, 'revenue') - getActualScenarioProp(record.groupResType, 'revenue')
      };
      record.maxSpillRevenue = {
        individual: getMaxRevenueScenarioProp(record.idvResType, 'spillRevenue'),
        group: getMaxRevenueScenarioProp(record.groupResType, 'spillRevenue')
      };
      record.actualSpillRevenue = {
        individual: getActualScenarioProp(record.idvResType, 'spillRevenue'),
        group: getActualScenarioProp(record.groupResType, 'spillRevenue')
      };
      record.spillRevenueGap = {
        individual: getActualScenarioProp(record.idvResType, 'spillRevenue') - getMaxRevenueScenarioProp(record.idvResType, 'spillRevenue'),
        group: getActualScenarioProp(record.groupResType, 'spillRevenue') - getMaxRevenueScenarioProp(record.groupResType, 'spillRevenue')
      };
      record.maxRecaptureRevenue = {
        individual: getMaxRevenueScenarioProp(record.idvResType, 'recaptureRevenue'),
        group: getMaxRevenueScenarioProp(record.groupResType, 'recaptureRevenue')
      };
      record.actualRecaptureRevenue = {
        individual: getActualScenarioProp(record.idvResType, 'recaptureRevenue'),
        group: getActualScenarioProp(record.groupResType, 'recaptureRevenue')
      };
      record.recaptureRevenueGap = {
        individual: getMaxRevenueScenarioProp(record.idvResType, 'recaptureRevenue') - getActualScenarioProp(record.idvResType, 'recaptureRevenue'),
        group: getMaxRevenueScenarioProp(record.groupResType, 'recaptureRevenue') - getActualScenarioProp(record.groupResType, 'recaptureRevenue')
      };
      record.fcDemand = {
        individual: getActualScenarioProp(record.idvResType, 'fcDemand'),
        group: getActualScenarioProp(record.groupResType, 'fcDemand')
      };
      record.actualSale = {
        individual: getActualScenarioProp(record.idvResType, 'sale'),
        group: getActualScenarioProp(record.groupResType, 'sale')
      };
      record.maxSale = {
        individual: getMaxRevenueScenarioProp(record.idvResType, 'sale'),
        group: getMaxRevenueScenarioProp(record.groupResType, 'sale')
      };
      record.maxRecapture = {
        individual: getMaxRevenueScenarioProp(record.idvResType, 'recapture'),
        group: getMaxRevenueScenarioProp(record.groupResType, 'recapture')
      };
      record.actualRecapture = {
        individual: getActualScenarioProp(record.idvResType, 'recapture'),
        group: getActualScenarioProp(record.groupResType, 'recapture')
      };
      record.maxSpill = {
        individual: getMaxRevenueScenarioProp(record.idvResType, 'spill'),
        group: getMaxRevenueScenarioProp(record.groupResType, 'spill')
      };
      record.actualSpill = {
        individual: getActualScenarioProp(record.idvResType, 'spill'),
        group: getActualScenarioProp(record.groupResType, 'spill')
      };
      record.saleGap = {
        individual: getMaxRevenueScenarioProp(record.idvResType, 'sale') - getActualScenarioProp(record.idvResType, 'sale'),
        group: getMaxRevenueScenarioProp(record.groupResType, 'sale') - getActualScenarioProp(record.groupResType, 'sale')
      };
      record.spillGap = {
        individual: getActualScenarioProp(record.idvResType, 'spill') - getMaxRevenueScenarioProp(record.idvResType, 'spill'),
        group: getActualScenarioProp(record.groupResType, 'spill') - getMaxRevenueScenarioProp(record.groupResType, 'spill')
      };
      record.recapGap = {
        individual: getMaxRevenueScenarioProp(record.idvResType, 'recapture') - getActualScenarioProp(record.idvResType, 'recapture'),
        group: getMaxRevenueScenarioProp(record.groupResType, 'recapture') - getActualScenarioProp(record.groupResType, 'recapture')
      };
      record.maxOpenPct = {
        individual: getMaxRevenueScenarioProp(record.idvResType, 'openPercent'),
        group: getMaxRevenueScenarioProp(record.groupResType, 'openPercent')
      };
      record.actualOpenPct = {
        individual: getActualScenarioProp(record.idvResType, 'openPercent'),
        group: getActualScenarioProp(record.groupResType, 'openPercent')
      };
      record.hostShare = {
        individual: getActualScenarioProp(record.idvResType, 'hostShare'),
        group: getActualScenarioProp(record.groupResType, 'hostShare')
      };
    });
    return dataset;
  };
  function getActualScenarioProp(resType, prop) {
    if (resType) {
      if (resType.actualScenario) {
        switch (prop) {
          case 'spill':
            return resType.actualScenario.spill;
          case 'recapture':
            return resType.actualScenario.recapture;
          case 'revenue':
            return resType.actualScenario.revenue;
          case 'hostShare':
            return resType.actualScenario.hostShare;
          case 'openPercent':
            return resType.actualScenario.openPercent;
          case 'sale':
            return resType.actualScenario.sale;
          case 'fcDemand':
            return resType.actualScenario.fcDemand;
          case 'recaptureRevenue':
            return resType.actualScenario.recaptureRevenue;
          case 'spillRevenue':
            return resType.actualScenario.spillRevenue;
          default:
        }
      }
    }
    return 0;
  }
  function getMaxRevenueScenarioProp(resType, prop) {
    if (resType) {
      if (resType.maxRevenueScenario) {
        switch (prop) {
          case 'spill':
            return resType.maxRevenueScenario.spill;
          case 'recapture':
            return resType.maxRevenueScenario.recapture;
          case 'revenue':
            return resType.maxRevenueScenario.revenue;
          case 'hostShare':
            return resType.maxRevenueScenario.hostShare;
          case 'openPercent':
            return resType.maxRevenueScenario.openPercent;
          case 'sale':
            return resType.maxRevenueScenario.sale;
          case 'fcDemand':
            return resType.maxRevenueScenario.fcDemand;
          case 'recaptureRevenue':
            return resType.maxRevenueScenario.recaptureRevenue;
          case 'spillRevenue':
            return resType.maxRevenueScenario.spillRevenue;
          default:
        }
      }
    }
    return 0;
  }
  return SkinnyMarketCabinSposOptGroupTransformer;
};
SkinnyMarketCabinSposOptGroupTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = SkinnyMarketCabinSposOptGroupTransformerFactory;